// src/features/equipment/pages/EquipmentDetailsPage/components/EquipmentImageCard.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Typography,
} from '@mui/material';
import { Devices as DevicesIcon } from '@mui/icons-material';
import { getEquipmentImageByModel } from '../../../utils/getEquipmentImage';

export default function EquipmentImageCard({ equipment }) {
  const { t } = useTranslation('equipment');
  const imageUrl = getEquipmentImageByModel(equipment.model);

  return (
    <Box sx={{ height: '100%' }}>
      <Box
          sx={{
            minHeight: 300,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'grey.50',
            borderRadius: 2,
            p: 3,
          }}
        >
          {imageUrl ? (
            <Box
              sx={{
                width: '100%',
                height: 300,
                backgroundImage: `url(${imageUrl})`,
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
              }}
            />
          ) : (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              gap={2}
            >
              <DevicesIcon sx={{ fontSize: 64, color: 'text.disabled' }} />
              <Typography variant="body2" color="text.secondary">
                {t('equipment:messages.no_image_available')}
              </Typography>
            </Box>
          )}
        </Box>

        {imageUrl && (
          <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
            {t('equipment:messages.reference_image')}
          </Typography>
        )}
    </Box>
  );
}